/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React from 'react'
import { observer } from 'mobx-react'
import { NavLink } from 'react-router-dom'
import './TopNavbar.scss'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { ITopNavBarApiClient } from '../../services/TopNavBarApiClient/contracts'
import { SettingsManager } from '../../configuration/SettingsManager'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ITopNavbarProps {
	//code related to your props goes here
}

export interface ITopNavbarState {
	authorizedForFacility: boolean
}

@observer
export class TopNavbar extends React.Component<ITopNavbarProps, ITopNavbarState> {
	@injectProperty('ITopNavBarApiClient')
	public topNavBarApiClient!: ITopNavBarApiClient

	constructor(props: Readonly<ITopNavbarProps>) {
		super(props)

		this.state = {
			authorizedForFacility: false,
		}
	}

	componentDidMount(): void {
		const facilityConfig = localStorage.getItem('Permission_' + SettingsManager.PRODUCT_PERMISSION_FOR_FACILITY_CONFIGURATION)
		if (facilityConfig !== null && typeof facilityConfig !== 'undefined') {
			if (facilityConfig === 'true') {
				this.setState({ authorizedForFacility: true })
			}
		} else {
			this.topNavBarApiClient.getAuthorizationStatus(SettingsManager.PRODUCT_PERMISSION_FOR_FACILITY_CONFIGURATION).then(responseFacility => {
				if (responseFacility === true) {
					this.setState({ authorizedForFacility: true })
				} else {
					this.setState({ authorizedForFacility: false })
				}
				localStorage.setItem('Permission_' + SettingsManager.PRODUCT_PERMISSION_FOR_FACILITY_CONFIGURATION, this.state.authorizedForFacility === true ? 'true' : 'false')
			})
		}
	}

	render(): React.ReactNode {
		return (
			<div className="TopNavTabs">
				<div className="row-fluid">
					<div className="span12">
						<div className="tabbable">
							<nav>
								<ul className="nav nav-tabs gaTrackTab">
									<li>
										<NavLink to="/CoverageDiscoveryRequest/" activeClassName="TopNavTabsActiveTab">
											Request
										</NavLink>
									</li>
									<li>
										<NavLink to="/requesthistory/" activeClassName="TopNavTabsActiveTab">
											History
										</NavLink>
									</li>
									<li>
										<NavLink to="/batches/" activeClassName="TopNavTabsActiveTab">
											Batches
										</NavLink>
									</li>
									{this.state.authorizedForFacility === true ? (
										<li>
											<NavLink to="/facilities" activeClassName="TopNavTabsActiveTab">
												Facilities
											</NavLink>
										</li>
									) : null}
								</ul>
							</nav>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
